import { render, staticRenderFns } from "./PaperCheck.vue?vue&type=template&id=29df4402&scoped=true&"
import script from "./PaperCheck.vue?vue&type=script&lang=ts&"
export * from "./PaperCheck.vue?vue&type=script&lang=ts&"
import style0 from "./PaperCheck.vue?vue&type=style&index=0&id=29df4402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29df4402",
  null
  
)

export default component.exports